import { UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn } from "@angular/forms";

import { HuskMigCredentialsService } from "@e-forsyning/common/auth";

export class LoginFormBuilder {
    public static opretForm(huskMigCredentialsService: HuskMigCredentialsService): UntypedFormGroup {
        const { brugernavn, kodeord, huskMig } = huskMigCredentialsService.hent();
        const erEmail = isNaN(Number(brugernavn));

        const builder = new UntypedFormBuilder();
        return builder.group({
            forbrugerNrGroup: builder.group({
                forbrugerNr: [(!erEmail && brugernavn) || null, []],
                kode: [(!erEmail && kodeord) || null, [Validators.required]]
            }),
            emailGroup: builder.group({
                email: [(erEmail && brugernavn) || "", emailOrShortLettersOrDigits()],
                adgangskode: [(erEmail && kodeord) || null, [Validators.required]]
            }),
            huskMig: [huskMig]
        });
    }
}

export function emailOrShortLettersOrDigits(): ValidatorFn {
    const email = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    const letters1to8 = /^[A-Za-z]{1,8}$/;
    const digits = /^\d+$/;
    return (c) => {
        const v = String(c.value ?? "").trim();
        if (!v) return null;
        if (digits.test(v)) return null;
        if (letters1to8.test(v)) return null;
        if (email.test(v)) return null;
        return { emailOrShortLettersOrDigits: true };
    };
}
